import React, { useState } from 'react'
import _ from 'lodash'
import numeral from 'numeral'
import {
  Div, H4, Loading, P, SmallText, Label,
} from 'konsys-ui'
import moment from 'moment-timezone'
import { useQuery, useMutation } from '@apollo/react-hooks'
import {
  LargeTextWithLabel, Remark, Collapse, TableList, FileListWithModal,
} from '../../../components/common'
import { theme } from '../../../styles/_variables'
import { TIRE_GOOD_RECEIVED_INFO } from '../../../constants/graph/query'

export default ({ props }) => {
  const { loading: infoLoading, data: infoData, error: infoError } = useQuery(TIRE_GOOD_RECEIVED_INFO, { variables: { id: props.match.params.id } })
  const [openCollapse, setOpenCollapse] = useState(true)
  if (infoLoading && _.isUndefined(infoData)) return <Loading center='true' />
  const data = infoData.GoodReceiveTireInfo
  const tableStyled = {
    0: {},
    1: {
      width: '33%',
    },
    2: {
      width: '33%',
    },
  }

  const headerData = [
    {
      text: 'สินค้า',
    }, {
      text: 'หมายเลข serial',
      textAlign: 'right',
    }, {
      text: 'จำนวนที่รับเข้า',
      textAlign: 'right',
    },
  ]

  const TableListData = data.GoodReceiveTireItem.map((v) => {
    const orderData = v.OrderItem
    return (
      [
        {
          text: <Div>
            <P display='block'>{v.OrderItem ? v.OrderItem.InventoryOption.inventory.productName : v.InventoryOption.inventory.productName}</P>
            {/* <SmallText bold color={theme.color.heather}>{poDetail}</SmallText> */}
          </Div>,
          label: {
            text: <Div>
              <SmallText display='block'><Label margin='0 4px 0 0'>Sku: </Label>{v.OrderItem ? v.OrderItem.InventoryOption.inventory.sku : v.InventoryOption.inventory.sku}</SmallText>
              <SmallText display='block'><Label margin='0 4px 0 0'>Brand: </Label>{v.OrderItem ? v.OrderItem.InventoryOption.inventory.brand : v.InventoryOption.inventory.brand}</SmallText>
            </Div>,
          },
        },
        { text: `${_.map(v.serials, d => d.serialNumber).join(', ')}`, textAlign: 'right' },
        { text: v.OrderItem ? `${numeral(v.quantity).format('0,0.00')} (จากจำนวนทั้งหมด ${numeral(orderData.quantity).format('0,0.00')})` : `${numeral(v.quantity).format('0,0.00')}`, textAlign: 'right' },
      ]
    )
  })

  const poRef = _.compact(_.reduce(data.orderItemGR, (array, n) => [...array, _.isEmpty(n.orderItem) || _.isEmpty(n.orderItem.purchaseOrder) || _.isEmpty(n.orderItem.purchaseOrder.number) ? null : { text: n.orderItem.purchaseOrder.number }], []))

  return (
    <Div>
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <H4 bold color={theme.color.primaryColor}>{data.number}</H4>
        {/* <P bold color={status.color}>{status.text}</P> */}
      </Div>
      <Div margin='24px 0'>
        <Div margin='0 0 16px' display='flex' alignItems='flex-start' moreStyle={{ flexWrap: 'wrap' }}>
          <LargeTextWithLabel margin='8px 24px 0 0' title={{ text: 'วันที่สร้างใบ GR' }} content={{ text: moment.tz(data.createdAt, 'Asia/Bangkok').format('DD/MM/YY') }} />
          <LargeTextWithLabel margin='8px 24px 0 0' title={{ text: 'หมายเลขใบรับสินค้า' }} content={{ text: data.refId }} />
          {
            !_.isEmpty(data.supplierRefId)
            && <LargeTextWithLabel margin='8px 24px 0 0' title={{ text: 'หมายเลขใบรับสินค้า' }} content={{ text: data.supplierRefId }} />
          }
          <LargeTextWithLabel
            margin='8px 24px 0 0'
            title={{ text: 'ใบ PO ที่เกี่ยวข้อง' }}
            content={_.isEmpty(data.PurchaseOrder) ? { text: '-' } : { text: data.PurchaseOrder.number }}
          />
          {/* <LargeTextWithLabel margin='8px 24px 0 0' title={{ text: dateType[1].text }} content={{ text: _.isEmpty(data.paymentDueDate) ? '-' : moment.tz(data.paymentDueDate, 'Asia/Bangkok').format('DD/MM/YY') }} /> */}
          {
            !_.isEmpty(data.Supplier)
            && <LargeTextWithLabel margin='8px 24px 0 0' title={{ text: 'Supplier' }} content={{ text: data.Supplier.name }} />
          }
          <LargeTextWithLabel margin='8px 24px 0 0' title={{ text: 'ชื่อผู้รับสินค้า' }} content={{ text: data.User ? `${data.User.firstname} ${data.User.lastname}` : '-' }} />
        </Div>
        {
          !_.isEmpty(data.GoodReceiveTireFiles)
          && <Div display='inline-block' style={{ maxWidth: '100%', wordBreak: 'break-all' }} margin='0 0 16px'>
              <SmallText bold display='block'>เอกสาร</SmallText>
              <FileListWithModal files={data.GoodReceiveTireFiles} />
            </Div>
        }
        <Remark description={_.isEmpty(data.remarks) ? '-' : data.remarks} />
      </Div>
      {
        <Collapse text='รายละเอียดสินค้า' fullHeight open={openCollapse} onClick={() => setOpenCollapse(!openCollapse)}>
          <Div>
            <TableList data={TableListData} headerData={headerData} columnStyled={tableStyled} />
          </Div>
        </Collapse>
      }
    </Div>
  )
}
